import LanguageLabel from "./LanguageLabel";
import React, { createContext, useContext } from "react";
import { MenuItem, Tab, Tabs, TextField } from "@mui/material";

export const MedicineWorkspaceContext = createContext(null);
export const useMedicineWorkspace = () => useContext(MedicineWorkspaceContext);

export function MedicineLanguageTabs() {
  const workspace = useMedicineWorkspace();
  if (!workspace) return null;
  const languages = workspace.languages.filter(item => ['en','cn','ru','es','sa','pt'].includes(item.langCode));
  return <Tabs value={workspace.language} onChange={(_, code) => workspace.changeLanguage(code)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Medicine language versions" sx={{ mb: 2, minWidth: 0, borderBottom: '1px solid', borderColor: 'divider' }}>{languages.map(item => <Tab key={item.langCode} value={item.langCode} disabled={workspace.busy} label={<LanguageLabel code={item.langCode}>{item.langName || item.langCode.toUpperCase()}</LanguageLabel>} />)}</Tabs>;
}

export function MedicineLanguageSelect() {
  const workspace = useMedicineWorkspace();
  if (!workspace) return null;
  return <TextField select label="Medicine language" size="small"
    value={workspace.language} disabled={workspace.busy || !workspace.languages.length}
    inputProps={{ "aria-label": "Medicine page language" }}
    onChange={event => workspace.changeLanguage(event.target.value)}
    sx={{ minWidth: { xs: 125, sm: 155 }, maxWidth: 200 }}>
    {workspace.languages.map(language => <MenuItem key={language.langCode} value={language.langCode}>
      <LanguageLabel code={language.langCode}>{language.langName || language.langCode.toUpperCase()}</LanguageLabel>
    </MenuItem>)}
  </TextField>;
}
